/**
 * dialog公共代码
 */
export default {
  props: {
    title: {
      type: String,
      default: '弹窗'
    },
    height: {
      type: [String, Number],
      // 默认值是双数，转换成px保证是双数，防止出现字体发虚
      default: '80vh'
    },
    width: {
      type: [String, Number],
      default: '75%'
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    show() {
      this.$emit('update:visible', true);
    },
    hide() {
      return this.getDialog().hide();
    },
    getDialog () {
      return this.$refs.dialog;
    }
  }
};
